import type { company, forexDataTable, investmentsDataTable, allDataTable } from "./types";
import companyList from "../../data/companyList.json";
import companyData from "../../data/companyData.json";
import myMovementData from "../../data/myMovementsData.json"

import type {movementList} from "../../service/myMovement/type"
import forexData from "../../data/bankerLastMovementForexItems.json"
import investmentsData from "../../data/bankerLastMovementInvestmentsItems.json"
export class heritageService {
  async myEmployeeList(clientId: number): Promise<company[]> {
    const companiesList = companyList.data.filter(
      (heritage: { clientId: number }) => heritage.clientId === clientId
    );
    return companiesList as company[]
  }


  async getEmployeeId(companyId: number): Promise<company | null> {
    const company = companyData.data.find((heritage: { id: number }) => heritage.id === companyId);
    if (company) {
      return company;
    }
    return null
  }

  async getFirstEmployee(clientId: number): Promise<company | null> {
    const companyFound = companyData.data.find((heritage: { clientId: number }) => heritage.clientId === clientId);
    return companyFound || null;
  }

  async getForexData(clientId: number): Promise<forexDataTable[]> {
    const data = (forexData.data as forexDataTable[])
      .filter(item => item.client_id === clientId)

    return data;
  }
  
  async getInvestmentsData(clientId: number): Promise<investmentsDataTable[]> {
    const data = (investmentsData.data as investmentsDataTable[])
      .filter(item => item.client_id === clientId)

    return data;
  }

 async getAllData(clientId: number): Promise<movementList[]> {
  const data = (myMovementData.data as movementList[])
    .filter(item => item.clientId === clientId)
  return data;
}
}
